<script>
import TitleBannersManagement from "./TitleBannersManagement.vue";
import FaqWorkManagement from "./FaqWorkManagement.vue";
import OnlineFormMobNotVisible from "../Other/OnlineFormMobNotVisible.vue";
import CostServicesManagement from "./CostServicesManagement.vue";
import OnlineFormMob from "../Other/OnlineFormMob.vue";
import OurServices from "../Main/OurServices.vue";
import ReviewsBlock from "../Main/ReviewsBlock.vue";
import FaqQues from "../Other/FaqQues.vue";
import BtnApplication from "../Other/BtnApplication.vue";
import FaqWork from "../Main/FaqWork.vue";

export default {
  name: "MainManagement",
  components: {
    FaqWork,
    BtnApplication,
    FaqQues,
    OurServices,
    OnlineFormMob,
    CostServicesManagement,
    OnlineFormMobNotVisible,
    FaqWorkManagement,
    TitleBannersManagement,
    ReviewsBlock,

  },
  data() {
    return {
      workLocal: [
        {
          'title': 'Консультация',
          'desc': '<ul><li>Уточнение исходных данных</li>' +
              '            <li>Определение инвестиционных целей</li>' +
              '            <li>Анализ текущего рынка недвижимости</li></ul>',
          'color': 'blue',
          "mobile_uniq" : true,
          "svg_back" : "<svg class=\"substrate-white first reinvest mobile\" preserveAspectRatio='none' width=\"358\" height=\"153\" viewBox=\"0 0 358 153\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
              "                            <path d=\"M202.98 42C209.189 42 215.123 39.4335 219.376 34.9083C227.028 26.7657 243.666 0 254.84 0H328C344.569 0 358 13.4315 358 30V123C358 139.569 344.569 153 328 153H30C13.4315 153 0 139.569 0 123V52.631C0 46.3136 8.55333 42 14.8708 42H202.98Z\" fill=\"#F7F7F7\"></path>\n" +
              "                        </svg>",
          "svg_num" : "<svg class=\"figure one mobile\" width=\"34\" height=\"58\" viewBox=\"0 0 34 58\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
              "                            <path d=\"M4 31C7.57672 30.1935 13.0667 29.0323 20 20C26.9333 10.9677 29.1746 5.34409 30 4L18 54H30H4\" stroke=\"#323232\" stroke-width=\"7\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path>\n" +
              "                        </svg>"
        },
        {
          'title': 'Хоумстейджинг',
          'desc': '<ul><li>Клининг</li>' +
              '            <li>Мелкий ремонт</li>' +
              '            <li>Рекомендации по интерьеру</li></ul>',
          'color': 'lite-blue',
          "mobile_uniq" : true,
          "svg_back" : "<svg class=\"substrate-white second management mobile\" preserveAspectRatio='none' width=\"358\" height=\"187\" viewBox=\"0 0 358 187\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
              "                            <path d=\"M164.05 74.0656C153.24 73.8769 143.367 67.8862 138.209 58.3846L128.889 41.2194C123.173 30.6925 105.62 0 93.6419 0H27.0063C12.0911 0 0 12.0911 0 27.0063V157C0 173.569 13.4315 187 30 187H328C344.569 187 358 173.569 358 157V89.1563C358 82.0943 349.963 77.3108 342.902 77.1875L164.05 74.0656Z\" fill=\"#F7F7F7\"></path>\n" +
              "                        </svg>",
          "svg_num" : "<svg class=\"figure two mobile\" width=\"36\" height=\"53\" viewBox=\"0 0 36 53\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
              "                            <path d=\"M32.0198 45.0504C32.0913 45.0504 32.2727 45.0504 32.5211 45.0504C34.4419 45.0504 36 46.6075 36 48.5284C36 50.4492 34.4419 52.0063 32.5211 52.0063C32.2727 52.0063 32.0913 52.0063 32.0198 52.0063C26.7495 52.0063 23.5194 51.1861 20.0791 48.0315C16.712 50.6726 12.7934 53 9.13348 53C8.69429 53 8.57761 52.0797 8.13842 52.0063C4.11255 51.6395 0.983143 49.6389 0.177969 46.0441C-0.554008 42.5227 1.01069 38.9349 4.15819 37.1008C5.91494 36.0738 8.79504 34.7866 13.1137 36.1071C15.09 36.694 16.9613 37.6943 19.084 39.0882C22.7439 34.3196 25.2443 28.3579 26.0494 22.1954C26.5618 18.0137 26.2987 13.9058 25.0544 11.2647C23.81 8.697 22.0119 7.73009 19.084 7.28992C16.3757 6.9231 13.8022 6.96308 12.1186 8.28361C10.6636 9.42489 9.72287 11.0643 9.12362 12.5582C8.34555 14.4979 6.43128 15.9896 4.3623 15.6945C2.5324 15.4334 1.355 13.8732 1.90094 12.1073C2.78225 9.25649 4.6098 5.08722 8.13842 2.32143C11.3591 -0.172911 15.3944 -0.326232 20.0791 0.334034C29.668 1.80129 34.552 9.79706 33.0148 22.1954C32.0633 29.3116 29.2266 37.4141 25.0544 43.063C24.908 43.2098 24.2057 42.9163 24.0593 43.063C25.8161 44.3102 28.7259 45.0504 32.0198 45.0504ZM8.13842 46.0441C9.96836 46.2642 12.352 45.1572 14.1088 44.0567C11.986 42.9563 10.3046 43.063 9.13348 43.063C8.4747 43.063 7.50935 42.8429 7.14336 43.063C6.48458 43.4298 6.00191 43.5432 6.14831 44.0567C6.2947 44.8637 7.55284 45.9708 8.13842 46.0441Z\" fill=\"#323232\"></path>\n" +
              "                        </svg>"
        },
        {
          'title': 'Продвижение Недвижимости',
          'desc': '<ul><li>Создание, размещение рекламного объявления на онлайн площадках</li>' +
              '            <li>Прием и обработка звонков и сообщений от потенциальных клиентов</li>' +
              '            <li>Показы объекта потенциальным клиентам</li>' +
              '            <li>Согласование деталей договора</li>' +
              '            <li>Заселение Арендатора</li></ul>',
          'color': 'green',
          "mobile_uniq" : true,
          "svg_back" : "<svg class=\"substrate-white third reinvest mobile\" preserveAspectRatio='none' width=\"358\" height=\"328\" viewBox=\"0 0 358 328\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
              "                            <path d=\"M215.165 73C225.621 73 235.323 67.5554 240.771 58.6301L251.148 41.6301C258.012 30.3843 275.275 0 288.45 0H333.073C346.84 0 358 11.1602 358 24.9271V298C358 314.569 344.569 328 328 328H30C13.4315 328 0 314.569 0 298V87.5376C0 78.9425 12.0552 73 20.6503 73H215.165Z\" fill=\"#F7F7F7\"></path>\n" +
              "                        </svg>",
          "svg_num" : "<svg class=\"figure three mobile\" width=\"47\" height=\"52\" viewBox=\"0 0 47 52\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
              "                            <path d=\"M46.3835 29.9309C49.6645 41.8633 39.7153 56.1267 19.7377 50.8826C8.67235 47.965 2.62127 39.79 0.568538 31.7971C0.163917 30.2216 1.2776 28.718 2.88162 28.4477C4.54738 28.167 6.09952 29.3257 6.61265 30.9351C8.4804 36.7932 13.4399 42.757 21.7114 44.8964C38.6997 49.3805 41.9204 37.3225 40.4622 31.9263C39.5144 28.2022 36.2856 25.1511 32.5671 22.947C27.3776 25.7041 22.376 26.981 18.484 27.5557C14.1874 28.1902 10.8557 24.6232 10.8557 20.28C10.8557 15.6709 14.5649 11.9408 19.1369 12.5244C23.1904 13.0418 28.1394 14.0401 32.5671 15.9632C35.8481 13.8351 39.5873 10.2423 40.4622 5.98618H8.91439C7.26135 5.98618 5.9213 4.64613 5.9213 2.99309C5.9213 1.34005 7.26135 0 8.91439 0H46.3835V3.99079C46.3835 9.76696 43.6651 14.6241 38.4884 18.9562C42.2069 21.8443 45.2169 25.4468 46.3835 29.9309ZM16.777 20.4253C16.777 21.2427 17.4831 21.8853 18.2804 21.7053C20.0718 21.3007 21.7378 20.551 23.6852 19.9539C21.8631 19.5863 20.1951 19.2618 18.2417 19.0702C17.4483 18.9924 16.777 19.6281 16.777 20.4253Z\" fill=\"#323232\"></path>\n" +
              "                        </svg>"
        },
        {
          'title': 'Ведение Объекта',
          'desc': '<ul><li>Ведение Арендатора во время проживания</li>' +
              '            <li>Контроль своевременной оплаты арендной платы, коммунальных платежей</li>' +
              '            <li>Выселение Арендатора, контроль повреждений, финальный расчет</li>' +
              '            <li>Расчеты с управляющей компанией</li>' +
              '            <li>Общение с управляющей компанией по всем вопросам, относящимся к эксплуатации жилого помещения</li></ul>',
          'color': 'yellow',
          "mobile_uniq" : true,
          "svg_back" : "<svg class=\"substrate-white fourth mobile\" preserveAspectRatio='none' width=\"358\" height=\"366\" viewBox=\"0 0 358 366\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
              "                            <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M189.762 75.1303C178.513 74.9323 168.319 68.4569 163.357 58.3579L154.615 40.5652V40.5652C149.677 30.5149 132.256 0 121.059 0L30 0C13.4315 0 0 13.4315 0 30L0 336C0 352.569 13.4315 366 30 366L328 366C344.569 366 358 352.569 358 336L358 86.0838C358 81.3746 353.364 78.0096 348.656 77.9267V77.9267L189.762 75.1303ZM358 0.219537C358 0.342295 357.899 0.441199 357.777 0.439039L332.83 0L357.78 0C357.902 0 358 0.0982898 358 0.219537V0.219537Z\" fill=\"#F7F7F7\"></path>\n" +
              "                        </svg>",
          "svg_num" : "<svg class=\"figure four mobile\" width=\"39\" height=\"53\" viewBox=\"0 0 39 53\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n" +
              "                            <path d=\"M32 45.0004H35.0002C37.2092 45.0004 39 46.7912 39 49.0002C39 51.2092 37.2092 53 35.0002 53H22.9998C20.7908 53 19 51.2092 19 49.0002C19 46.7912 20.7908 45.0004 22.9998 45.0004H25V40.0007H0V37.0009C0 24.4509 2.33592 14.5798 9 8.00243C17.4058 -0.389407 28.5456 0.00286739 29 0.00286739H32V33.0011H35.5002C37.4331 33.0011 39 34.568 39 36.5009C39 38.4338 37.4331 40.0007 35.5002 40.0007H32V45.0004ZM25 33.0011V7.00249C22.2738 7.60731 20.3476 8.49028 18 10.0023C11.4116 14.4629 7.60583 22.2656 7 33.0011H25Z\" fill=\"#323232\"></path>\n" +
              "                        </svg>"
        },
      ],
      servicesLocal: [

        {
          'tarif' : 'Инвестиция',
          'img' : 'services1.png',
          'desc' : 'Предлагаем услуги по подбору и покупке ликвидного объекта  недвижимости и последующим управлением с целью увеличения финансового состояния.',
          'color_line1' : "blue",
          'color_line2' : "blue",
          'route' : '/investition'

        },
        {
          'tarif' : 'Управление',
          'img' : 'services3.png',
          'desc' : 'Предлагаем услуги по подготовке\n' +
              'объекта недвижимости к аренде с учетом эстетических и\n' +
              'маркетинговых принципов,\n' +
              'увеличивая арендную стоимость и экономя Ваше время.',
          'route' : '/management',
          'color_line1' : "blue",
          'color_line2' : "blue",
        },
        {
          'tarif' : 'Реинвестиция',
          'img' : 'services2.png',
          'desc' : 'Предлагаем услуги по продаже\n' +
              'имеющего объекта недвижимости\n' +
              'с последующей покупкой более\n' +
              'ликвидного объекта и\n' +
              'дальнейшим его управлением.',
          'route' : '/reinvestition',
          'color_line1' : "orange",
          'color_line2' : "green",
        },
        {
          'tarif' : 'Хоумстейджинг',
          'img' : 'services4.png',
          'desc' : 'Мы преображаем интерьер,\n' +
              'так, чтобы потенциальные арендаторы\n' +
              'и покупатели в него влюбились.\n' +
              'Это поможет сдать и продать объект\n' +
              'быстро и по более высокой цене.',
          'route' : '/home?filter=home',
          'color_line1' : "orange",
          'color_line2' : "green",
        },
        {
          'tarif' : 'Ремонт',
          'img' : 'services5.png',
          'desc' : 'Осуществляем полный комплекс\n' +
              'услуг по ремонту объекта недвижимости,\n' +
              'начиная от разработки\n' +
              'дизайн-проекта и заканчивая\n' +
              'мебелировкой помещений.',
          'route' : '/home?filter=home',
          'color_line1' : "orange",
          'color_line2' : "green",
        }
      ],
      reviews:[
        {
          'avatar' : 'pony.webp',
          'name' : 'Alexander A. M.',
          'category' : 'инвестиции',
          'date' : '03.03.25',
          'message' : 'Прекрасные партнеры для хозяев апартаментов и квартир. Оперативно отремонтировали нам апартаменты, все с нами согласовали, решили все возникшие проблемы с застройщиком, управляющей компанией и коммунальными службами без необходимости личного присутствия хозяев. Быстро и точно предоставляют отчетность, напоминают о необходимых действиях, вы всегда знаете, чего ожидать.\n',

        },
        {
          'avatar' : 'rob.webp',
          'name' : 'Наталья К.',
          'category' : 'инвестиции',
          'date' : '10.12.24',
          'message' : 'Хочу поблагодарить команду «Бизнес Аренда» за профессиональный подход к своему делу. За четкую организацию процесса сдачи жилья, сопровождение клиентов, готовность незамедлительно решать возникшие вопросы, в том числе и нестандартные ситуации. Работаю с «Бизнес Арендой» уже третий год как инвестор жилья и не знаю проблем, все вопросы команда взяла на себя, что очень ценно. Рекомендую данного поставщика услуг, желаю ребятам роста и успехов в их профессиональном деле.',

        },
        {
          'avatar' : 'hat-student.webp',
          'name' : 'Екатерина В.',
          'category' : 'инвестиции',
          'date' : '26.07.24',
          'message' : 'По рекомендации близкого друга вышла на этих ребят, решила через них сдать квартиру в спальном районе у МКАДа, так как устала сама решать все вопросы по сдаче, эти звонки, показы и проч.. В итоге после детального обсуждения мне предложили продать эту трешку у МКАда и на эти средства купить студию в бетоне в пределах ТТК, долго думали и решили в итоге попробовать. Тем более, что за ремонт в студии взялись эти же ребята на оставшиеся с продажи деньги. На протяжении всего времени был доступ к видео хода ремонта, все отчеты, финансы прозрачно. В итоге -современный дизайн и студия "ушла" в аренду сразу же на долгий срок за очень приличные деньги. Денег приносит больше, чем старая трёшка у МКАД и все вопросы по управлению решают эти ребята. В общем все гут, можно иметь дело.',

        },
      ],
      slider:[
        {
          'avatar' : 'pony.webp',
          'name' : 'Alexander A.',
          'category' : 'инвестиции',
          'date' : '03.03.25',
          'message' : 'Прекрасные партнеры для хозяев апартаментов и квартир. Оперативно отремонтировали нам апартаменты, все с нами согласовали, решили все возникшие проблемы с застройщиком, управляющей компанией и коммунальными службами без необходимости личного присутствия хозяев. Быстро и точно предоставляют отчетность, напоминают о необходимых действиях, вы всегда знаете, чего ожидать.\n',
        },
        {
          'avatar' : 'rock.webp',
          'name' : 'Юлия',
          'category' : 'инвестиции',
          'date' : '07.03.25',
          'message' : 'Заезжали по адресу : ЖК Лайнер Запад.\n' +
              'Апартаменты понравились ! Очень удобное местоположенте : рядом находится тц ,в котором можно купить все необходимое ,в самом жк также есть магазины,салоны красоты ,стоматолигии,аптеки и прочее . Вообщем,все в шаговой доступности ,что очень круто 🤓\n' +
              '\n' +
              'Рядом есть метро - от которого можно доехать без проблем в любую точку!\n' +
              '\n' +
              'Сами апарты очень уютные : есть телевизор ,кондиционер , стиральная машина-сушилка ; ремонт выполнен современно в светлых тонах.Достаточно тихо ,нет никакой суматохи по ночам\n' +
              '\n' +
              'Арендодатели постоянно на связи ,отвечали на все вопросы !\n' +
              '\n' +
              'Также при заезде мы выбрали услугу с клинингом раз в месяц - что очень оказалочь очень удобным !\n' +
              '\n' +
              'Однозначно рекомендую💗',
        },
        {
          'avatar' : 'bunny.webp',
          'name' : 'Дарья Г.',
          'category' : 'инвестиции',
          'date' : '12.12.24',
          'message' : 'Очень классная команда! Ответственные, честные и приятные. Была необходимость срочно квартира на месяц в связи с переездом, оперативно показали, завезли все необходимы принадлежности, учли пожелания по дополнительной обстановке квартиры, были на связи всегда!) жила в сердце столице с большим удовольствием. Обязательно буду обращаться к ним, так как все комфортно, быстро и надежно 🫶🏽',
        },
        {
          'avatar' : 'review-kitty.webp',
          'name' : 'Анна',
          'category' : 'инвестиции',
          'date' : '22.01.25',
          'message' : 'Жила полгода на Спартаке в чудесной уютной евродвушке, которую арендовала через Бизнес Аренду.\n' +
              '\n' +
              'Это были счастливые и спокойные месяцы, так как жить в апартах было очень комфортно, а все вопросы решались очень оперативно(а их было не много, так как квартира продумана до мелочей), взаимодействие с УК было максимально приятным, всегда знаешь, что тебе помогут и есть к кому обратиться\n' +
              '\n' +
              'Удобно, что жилье можно снять помесячно, это огромный плюс для людей, кто не ведь год живет в Москве. Благодарю всю команду за любовь к клиентам и свое дело! Желаю процветания!',
        },
        {
          'avatar' : 'hat-student.webp',
          'name' : 'Балконский',
          'category' : 'инвестиции',
          'date' : '22.01.25',
          'message' : 'Снимал у этой компании квартиру в ЖК Тринити. Прекрасный минималистичный интерьер в светлых тонах, удобный ортопедический матрас, бытовая техника отличная! Удобно, что есть свой мастер и клининг. Менеджер по работе с арендаторами приятная девушка, всегда на связи и готова помочь. Вернусь ещё, как буду в Москве. Мне понравилось!',
        },
        {
          'avatar' : 'croco.webp',
          'name' : 'Aleksey Ch.',
          'category' : 'инвестиции',
          'date' : '1.12.24',
          'message' : 'Хочу оставить только положительные отзывы и порекомендовать Александру и его партнерам. Все квартиры сделаны с очень хорошим, качественным ремонтом, надежной техникой. Квартиры чистые, приятно находиться в данных пространствах. Так же что очень важно что собственники являются честными и отзывчивыми людьми, с которыми приятно вести общение.',
        },
        {
          'avatar' : 'hat-student.webp',
          'name' : 'Юлия С.',
          'category' : 'инвестиции',
          'date' : '5.12.24',
          'message' : 'В Сердце Столицы с удовольствием живу уже 2 год. Безупречный дизайн апартаментов, продуманный до мелочей. Очень чуткое руководство! Отзывчивый персонал, на любые просьбы и вопросы самые быстрые ответы и предложения. Спасибо вам огромное за внимание и заботу!',
        },
        {
          'avatar' : 'bunny.webp',
          'name' : 'Ольга Ч.',
          'category' : 'инвестиции',
          'date' : '8.10.24',
          'message' : 'Хотела поблагодарить сотрудников Бизнес Аренды за качественный сервис, клиентоориентированность , красивый интерьер. Очень комфортно взаимодействовать, вежливое и внимательное отношение к клиентам. Я проживала в жк Движение Тушино 5 месяцев. Рядом с м Спартак. Всё новенькое, красивый дизайн, качественный ремонт.',
        },
      ],
      faqList: [
        {
          "title": "Как заключается договор с собственником квартиры?",
          "desc": "Мы заключаем с договор аренды на 11 мес. и далее уже можем его продлить. Договор заключается с нашей компанией, которая будет является арендатором. Квартиры мы сдаем по договору субаренды на основании заключенного договора аренды с вами как с собственником."
        },
        {
          "title": "Из каких этапов состоит пакет \"Инвестиция\"?",
          "desc": "<span>\n" +
              "            Пакет “Инвестиция” состоит из следующих этапов:\n" +
              "          </span>\n" +
              "          <ul>\n" +
              "            <li>Консультация</li>\n" +
              "            <li>Подбор недвижимости</li>\n" +
              "            <li>Покупка недвижимости с сопровождением сделки</li>\n" +
              "            <li>Капитальный ремонт объекта недвижимости</li>\n" +
              "            <li>Управление недвижимостью</li>\n" +
              "          </ul>"
        },
        {
          "title": "Из каких этапов состоит пакет \"Реинвестиция\"?",
          "desc": "<span>\n" +
              "            Пакет Реинвестиция” состоит из следующих этапов:\n" +
              "          </span>\n" +
              "          <ul>\n" +
              "            <li>Консультация</li>\n" +
              "            <li>Продажа текущего объекта недвижимости</li>\n" +
              "            <li>Подбор недвижимости</li>\n" +
              "            <li>Покупка недвижимости с сопровождением сделки</li>\n" +
              "            <li>Капитальный ремонт объекта недвижимости</li>\n" +
              "            <li>Управление недвижимостью</li>\n" +
              "          </ul>"
        },
        {
          "title": "Что такое хоумстейджинг?",
          "desc": "С английского хоумстейджинг переводится как «домашняя постановка». По сути, это подготовка квартиры, в основе которой лежат дизайнерские и психологические приемы. Применяется, чтобы продать или сдать объект быстро и по более высокой цене"
        },
        {
          "title": "Какие сроки оказания услуг?",
          "desc": "Срок оказания услуг зависит от выбранного пакета. Обычно мы подписываем договор на 3 месяца, однако по нашей практике этот срок составляет до 45 дней."
        },
        {
          "title": "Из каких этапов состоит пакет \"Управление\"?",
          "desc": "<span>\n" +
              "            Пакет “Управление” состоит из следующих этапов:\n" +
              "         </span>\n" +
              "          <ul>\n" +
              "            <li>Консультация</li>\n" +
              "            <li>Хоумстейджинг объекта недвижимости</li>\n" +
              "            <li>Продвижение объекта недвижимости</li>\n" +
              "            <li>Ведение объекта недвижимости</li>\n" +
              "          </ul>"
        }
      ]
    }
  }
}
</script>

<template>
  <div class="wrapper-content main-reinvest" id="main">
    <title-banners-management></title-banners-management>
    <faq-work
        page="management"
        title="Включает следующие этапы"
        :work="workLocal"></faq-work>
    <online-form-mob-not-visible></online-form-mob-not-visible>
    <cost-services-management></cost-services-management>
    <online-form-mob></online-form-mob>
    <our-services
        :services="servicesLocal"></our-services>
        
    <reviews-block
    :reviews="reviews" :slider="slider"></reviews-block>
    <faq-ques
        :faqlist="faqList"
    ></faq-ques>
    <btn-application></btn-application>
  </div>
</template>

<style scoped>

</style>